import { useTranslation } from "@motolynk/i18n";
import { Select } from "@motolynk/ui";

import { useCountries, useStates } from "../hooks";

interface GeoSelectProps {
  value?: string;
  onValueChange: (value: string) => void;
  id?: string;
  disabled?: boolean;
  "aria-invalid"?: boolean;
}

/** Country picker (active countries; value = ISO alpha-2). Use inside a `FormField`. */
export function CountrySelect({ disabled, ...props }: GeoSelectProps) {
  const { t } = useTranslation("geo");
  const countries = useCountries();
  return (
    <Select
      {...props}
      disabled={disabled || !countries.data}
      placeholder={countries.isError ? t("loadFailed") : t("country.placeholder")}
      options={(countries.data?.data ?? []).map((c) => ({ value: c.iso2, label: c.name }))}
    />
  );
}

export interface StateSelectProps extends GeoSelectProps {
  /** ISO alpha-2 of the chosen country; the list stays disabled until there is one. */
  country: string | undefined;
}

/** State / union territory picker for one country (value = state code, e.g. "MH"). */
export function StateSelect({ country, disabled, ...props }: StateSelectProps) {
  const { t } = useTranslation("geo");
  const states = useStates(country);
  const placeholder = !country
    ? t("state.chooseCountryFirst")
    : states.isError
      ? t("loadFailed")
      : states.data
        ? t("state.placeholder")
        : t("loading");
  return (
    <Select
      {...props}
      disabled={disabled || !states.data}
      placeholder={placeholder}
      options={(states.data?.data ?? []).map((s) => ({ value: s.code, label: s.name }))}
    />
  );
}
